import React from 'react';
import { ErrorBoundary } from '@/components/shared/ErrorBoundary';
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import { Button } from '@/components/ui/button';
import { RefreshCw, AlertTriangle } from 'lucide-react';

interface RelicsErrorBoundaryProps {
  children: React.ReactNode;
  fallbackMessage?: string;
}

export const RelicsErrorBoundary: React.FC<RelicsErrorBoundaryProps> = ({ 
  children, 
  fallbackMessage = "There was an error loading the relics." 
}) => {
  const handleRetry = () => {
    window.location.reload();
  };

  return (
    <ErrorBoundary
      fallback={
        <Alert variant="destructive" className="my-4 max-w-md mx-auto">
          <AlertTriangle className="h-4 w-4" />
          <AlertTitle>Relics Loading Error</AlertTitle>
          <AlertDescription className="space-y-3">
            <p>{fallbackMessage}</p>
            <Button
              variant="outline"
              size="sm"
              onClick={handleRetry}
              className="w-full"
            >
              <RefreshCw className="mr-2 h-4 w-4" />
              Retry Loading
            </Button>
          </AlertDescription>
        </Alert>
      }
    >
      {children}
    </ErrorBoundary>
  );
};